import { Table } from 'foundations-components/transitional/components/Table';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRecentlyCompletedAssignedContent } from '../../queries/assignedContentQueries';
import { NavMarker } from 'react-rhumb';
import ApiError from '../../../../components/Errors/ApiError';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { getPaginatedPosition } from '../../utils/paginationUtils';
import UserAvatarLink from '../common/UserAvatarLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { MY_TEAM_OVERVIEW_PAGE_SIZE } from '../../../pagination';
import EmptyOverviewCard from '../common/EmptyOverviewCard';
import { usePaginatedTable } from '../../hooks/usePaginatedTable';
import ContentTypeLabel from '../assignedContent/ContentTypeLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RecentlyCompletedAssignedContent = () => {
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const {
    recentlyCompletedAssignedContent,
    recentlyCompletedAssignedContentLoading,
    recentlyCompletedAssignedContentError
  } = useRecentlyCompletedAssignedContent();
  const {
    startIndex,
    paginatedData: contentToDisplay,
    pageCount,
    pageNumber,
    handlePageChange
  } = usePaginatedTable(recentlyCompletedAssignedContent, MY_TEAM_OVERVIEW_PAGE_SIZE);
  if (recentlyCompletedAssignedContentLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered",
      minHeight: "350px",
      size: "medium"
    });
  }
  if (recentlyCompletedAssignedContentError || !recentlyCompletedAssignedContent) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "RECENTLY_COMPLETED_ASSIGNED_CONTENT_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "RECENTLY_COMPLETED_ASSIGNED_CONTENT_LOADED",
    children: contentToDisplay.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "recently-completed-assigned-content-table",
        truncated: isMobile,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            width: "35%"
          }), /*#__PURE__*/_jsx("col", {
            width: "40%"
          }), /*#__PURE__*/_jsx("col", {
            width: "25%"
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.table.name"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.table.content"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.table.completed"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: contentToDisplay.map((item, index) => {
            const position = getPaginatedPosition(startIndex, index);
            return /*#__PURE__*/_jsxs("tr", {
              "data-test-id": "recently-completed-assigned-content-row",
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(UserAvatarLink, {
                  displayAvatar: isDesktop,
                  position: position,
                  userEmail: item.userEmail,
                  userId: item.userId,
                  userName: item.userName
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(ContentTypeLabel, {
                  contentId: item.contentId,
                  contentName: item.contentName,
                  contentType: item.contentType
                })
              }), /*#__PURE__*/_jsx("td", {
                children: item.completedDate && /*#__PURE__*/_jsx(FormattedDateTime, {
                  format: "ll",
                  value: item.completedDate
                })
              })]
            }, `${item.userId}-${item.assignmentId}`);
          })
        })]
      }), /*#__PURE__*/_jsx(Paginator, {
        onPageChange: handlePageChange,
        page: pageNumber,
        pageCount: pageCount,
        showButtonLabels: false
      })]
    }) : /*#__PURE__*/_jsxs(EmptyOverviewCard, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.noResultsTitle"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.noResultsDescription"
      })]
    })
  });
};
export default RecentlyCompletedAssignedContent;